import { Component, ElementRef, HostListener, ViewChild, output, signal } from '@angular/core';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { ConfigurationSaisieDonneesAnalyse } from '../../bo/configurationSaisieDonneesAnalyse';
import { DonneeAnalyse } from '../../bo/donneeAnalyse';
import { ReferentielDonneeAnalyse } from '../../bo/referentielDonneeAnalyse';
import { FonctionsService } from '../../services/fonctions-partagees.service';

@Component({
  selector: 'app-donnees-analyse-modale',
  templateUrl: './donnees-analyse-modale.component.html',
  styleUrls: ['./donnees-analyse-modale.component.scss'],
  standalone: false
})

export class DonneesAnalyseModaleComponent {
  @ViewChild('modalConfirmCancel') modalConfirmCancel: ModalDirective;
  @ViewChild('inputString') inputString: ElementRef;
  @ViewChild('inputNumber') inputNumber: ElementRef;
  tabConfigSaisie: ConfigurationSaisieDonneesAnalyse[];
  donneeAnalyseEntree: DonneeAnalyse;
  donneeAnalyse: DonneeAnalyse;
  annul = signal<boolean>(false);
  estProjet: boolean;
  siteId: number;
  valeurMinNb = signal<number>(-9999999999);
  valeurMaxNb = signal<number>(9999999999);
  success = signal<boolean>(false);
  modaleFermee = output<boolean>();
  erreurApi = signal<boolean>(false);

  constructor(private readonly bsModalRef: BsModalRef, private readonly http: HttpService, private readonly fonctionsService: FonctionsService) { }

  ngOnInit() {
    if (this.donneeAnalyseEntree && this.tabConfigSaisie) {
      this.donneeAnalyse = this.creerCopie(this.donneeAnalyseEntree);
    }
  }

  ngAfterContentInit() {
    setTimeout(() => {
      if (this.donneeAnalyse) {
        if (this.donneeAnalyse.referentielDonneeAnalyse.nomTypeReferentiel === 'string')
          this.inputString.nativeElement.focus();
        else if (this.donneeAnalyse.referentielDonneeAnalyse.nomTypeReferentiel === 'number')
          this.inputNumber.nativeElement.focus();
      }
    }, 500);
  }

  @HostListener('window:keydown.esc', ['$event'])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
    }
    this.showModalCancel();
  }

  onSubmit() {
    this.erreurApi.set(false);
    if (this.validationFormulaire()) {
      this.fonctionsService.loading_screen(true);
      this.donneeAnalyse.siteId = this.siteId; //force le siteId pour la sécurité.

      if (this.donneeAnalyse.referentielDonneeAnalyse.nomTypeReferentiel === 'string')
        this.donneeAnalyse.valeur = this.donneeAnalyse.valeur.trim();
      this.http.post<DonneeAnalyse, any>('AnalysisData', this.donneeAnalyse).subscribe(resultat => {
        if (resultat)
          this.success.set(true);
        else
          this.erreurApi.set(true);
        this.fonctionsService.loading_screen(false);
        if (!this.erreurApi()) {
          this.fonctionsService.launch_toast(this.success());
          this.bsModalRef.hide();
          this.modaleFermee.emit(this.success());
        }
      }, () => {
        this.erreurApi.set(true);
        this.fonctionsService.loading_screen(false);
      });
    }
  }

  validationFormulaire() {
    let formValide = true;
    // Pour les données de type number, on vérifie qu'elles font partie de l'interval autorisé
    if (this.donneeAnalyse.referentielDonneeAnalyse.nomTypeReferentiel === 'number') {
      this.donneeAnalyse.enErreur = false;
      let valeur = Number(this.donneeAnalyse.valeur) || null;
      if (valeur && (valeur < this.valeurMinNb() || valeur > this.valeurMaxNb())) {
        formValide = false;
        this.donneeAnalyse.enErreur = true;
      } else if (!valeur && this.donneeAnalyse.valeur != '0')
        this.donneeAnalyse.valeur = '';
    }
    return formValide;
  }

  showModalCancel() {
    if (this.diff()) {
      this.modalConfirmCancel.show();
    } else {
      this.annulModif();
    }
  }

  diff() {
    return this.donneeAnalyse.valeur !== this.donneeAnalyseEntree.valeur;
  }

  annulModif() {
    this.annul.set(true);
    this.bsModalRef.hide();
  }

  creerCopie(donneeRef: DonneeAnalyse) {
    let donnee = new DonneeAnalyse();
    donnee.donneeAnalyseId = donneeRef.donneeAnalyseId;
    donnee.projetId = donneeRef.projetId;
    donnee.referentielDonneeAnalyseId = donneeRef.referentielDonneeAnalyseId;
    donnee.tirId = donneeRef.tirId;
    donnee.siteId = donneeRef.siteId;
    donnee.valeur = donneeRef.referentielDonneeAnalyse.nomTypeReferentiel === 'number' ? donneeRef.valeur.replace(',', '.') : donneeRef.valeur;
    donnee.referentielDonneeAnalyse = new ReferentielDonneeAnalyse();
    donnee.referentielDonneeAnalyse.referentielDonneeAnalyseId = donneeRef.referentielDonneeAnalyseId;
    donnee.referentielDonneeAnalyse.nom = donneeRef.referentielDonneeAnalyse.nom;
    donnee.referentielDonneeAnalyse.nomTypeReferentiel = donneeRef.referentielDonneeAnalyse.nomTypeReferentiel;
    if (donneeRef.referentielDonneeAnalyse.nomUniteReferentiel)
      donnee.referentielDonneeAnalyse.nomUniteReferentiel = donneeRef.referentielDonneeAnalyse.nomUniteReferentiel;
    // Utilisé pour afficher ou non un message d'erreur
    donnee.enErreur = false;

    return donnee;
  }
}
